// extracted by mini-css-extract-plugin
module.exports = {"container":"propertiesList_container__3-Eah","card":"propertiesList_card__3NCAy"};